import React from "react";
import { useNavigate } from "react-router-dom";
import "./ProductCards.css";

import specialityImg from "../../assets/speciality.png";
import woodImg from "../../assets/wood.png";
import ferroImg from "../../assets/ferro.png";
import labImg from "../../assets/lab.png";
import metalsImg from "../../assets/metals.png";
import CuttingImg from "../../assets/CuttingImg.png";
import AbrasivesImg from "../../assets/AbrasivesImg.png";

const products = [
  {
    title: "Plating and Specialty Chemicals",
    image: specialityImg,
    path: "/products/plating-and-speciality-chemicals",
  },
  {
    title: "Basic and Lab Chemicals",
    image: labImg,
    path: "/products/basic-and-lab-chemicals",
  },
  {
    title: "Metals",
    image: metalsImg,
    path: "/products/metals",
  },
  {
    title: "Abrasives",
    image: AbrasivesImg,
    path: "/products/abrasives",
  },
  {
    title: "Cutting Tools",
    image: CuttingImg,
    path: "/products/cutting-tools",
  },
  {
    title: "Wood & Glass Coatings",
    image: woodImg,
    path: "/products/wood-glass-coatings",
  },
  {
    title: "Metal Coatings",
    image: ferroImg,
    path: "/products/metal-coatings",
  },  
  
];

const ProductCards = () => {
  const navigate = useNavigate();

  return (
    <section className="product-cards-section">
      <div className="product-cards-container">
        {products.map((product, index) => (
          <div
            key={index}
            className="product-card"
            onClick={() => navigate(product.path)}
            style={{ cursor: "pointer" }}
          >
            <div
              className="product-card-header"
              style={{ backgroundColor: product.color }}
            >
              <h3 className="product-card-title">{product.title}</h3>
              <button className="product-card-btn">➔</button>
            </div>
            <div
              className="product-card-image"
              style={{ backgroundImage: `url(${product.image})` }}
            ></div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default ProductCards;
